import { render, staticRenderFns } from "./starMark.vue?vue&type=template&id=065d5ce3&scoped=true"
import script from "./starMark.vue?vue&type=script&lang=js"
export * from "./starMark.vue?vue&type=script&lang=js"
import style0 from "./starMark.vue?vue&type=style&index=0&id=065d5ce3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d5ce3",
  null
  
)

export default component.exports